/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style3 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style4 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _tool = require('util/tool');

var _config = require('util/config');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('div', {
    className: 'tip'
}, void 0, '\u6682\u65E0\u6570\u636E');

var Main = function (_Component) {
    (0, _inherits3.default)(Main, _Component);

    function Main(props, context) {
        (0, _classCallCheck3.default)(this, Main);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

        _this.updates = function (uid) {
            //console.log(uid)
            var id = _this.props.params.id;

            _this.props.router.push({
                pathname: '/remote/' + uid + '/updateByStation/update/1'
            });
        };

        _this.state = {
            stationList: []
        };
        return _this;
    }

    (0, _createClass3.default)(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var stationIds = JSON.parse(window.localStorage.getItem("stationIds"));
            //console.log(stationIds)
            (0, _tool.http)(_config.apiJson.getSiteDeviceCountOfProduct, { stationIds: stationIds }).then(function (res) {
                //console.log(res)
                if (res && res.length > 0) {
                    var stationList = res;
                    _this2.setState({
                        stationList: stationList
                    });
                } else {
                    _message2.default.error("未查询到设备信息！");
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var stationList = this.state.stationList;

            var options = [];
            //console.log(stationList)
            stationList.map(function (item, key) {
                var tpl = (0, _jsx3.default)('div', {
                    className: 'station-list'
                }, key, (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, item.productName), (0, _jsx3.default)('li', {}, void 0, item.deviceCount), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_button2.default, {
                    onClick: _this3.updates.bind(_this3, item.productId)
                }, void 0, '\u7248\u672C\u5347\u7EA7'))));
                options.push(tpl);
            });
            //console.log(options.length)
            options = options.length ? options : _ref;
            return (0, _jsx3.default)('div', {
                className: 'device-list'
            }, void 0, options);
        }
    }]);
    return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
    id: '', // 应用关联使用的redux
    component: Main, // 接收数据的组件入口
    url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/station/index.jsx
// module id = 1510
// module chunks = 0